/**
 * Inline SVG <defs> block exposing the 6 brand gradients to any SVG icon
 * that wants to fill itself with one (via `fill="url(#coapp-grad-…)"` or
 * the `& path { fill: url(#…) }` CSS pattern). Mounted once at the top of
 * the rule builder so every node's icon has access without each node having
 * to re-declare the defs.
 */
export default function CoAppGradientDefs() {
	return (
		<svg width="0" height="0" style={{ position: "absolute", pointerEvents: "none" }} aria-hidden focusable="false">
			<defs>
				<linearGradient id="coapp-grad-primary" x1="0%" y1="0%" x2="100%" y2="100%">
					<stop offset="0%" stopColor="#02D5AB" />
					<stop offset="100%" stopColor="#0A7FA8" />
				</linearGradient>
				<linearGradient id="coapp-grad-purple" x1="0%" y1="0%" x2="100%" y2="100%">
					<stop offset="0%" stopColor="#D63AD9" />
					<stop offset="100%" stopColor="#8C30E0" />
				</linearGradient>
				<linearGradient id="coapp-grad-blue" x1="0%" y1="0%" x2="100%" y2="100%">
					<stop offset="0%" stopColor="#5BA0FF" />
					<stop offset="100%" stopColor="#2C66E0" />
				</linearGradient>
				<linearGradient id="coapp-grad-red" x1="0%" y1="0%" x2="100%" y2="100%">
					<stop offset="0%" stopColor="#E94136" />
					<stop offset="100%" stopColor="#B81E15" />
				</linearGradient>
				<linearGradient id="coapp-grad-orange" x1="0%" y1="0%" x2="100%" y2="100%">
					<stop offset="0%" stopColor="#FF7A3C" />
					<stop offset="100%" stopColor="#EE3A2D" />
				</linearGradient>
				<linearGradient id="coapp-grad-yellow" x1="0%" y1="0%" x2="100%" y2="100%">
					<stop offset="0%" stopColor="#FFD93B" />
					<stop offset="100%" stopColor="#F2A93B" />
				</linearGradient>
			</defs>
		</svg>
	);
}
